// extracted by mini-css-extract-plugin
export var statItem = "_gs-1";
export var statsRow = "_gs-0";